import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import img from '../../assets/cc-mini-front-expiry-date.png.js';
import img$1 from '../../assets/cc-mini-front-expiry-date@2x.png.js';
import styles from './CCExpiryDateIcon.module.scss.js';

const CCExpiryDateIcon = ({ className }) => {
    return (jsx("img", { className: classNames(styles.ccExpiryDateIcon, className), src: img, alt: "Expiration date", srcSet: `${img} 1x, ${img$1} 2x`, "data-zta": "cc-front-expiry-date" }));
};

export { CCExpiryDateIcon as default };
//# sourceMappingURL=CCExpiryDateIcon.js.map
